/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React, {useContext, useEffect, useState,useMemo,useCallback } from "react";
import Stockchart from "../stockchart_plotly";
import DisplayCards from "../metricCards";
import DynamicStockCharts from "../dynamicStockCharts_plotly";
import FundaTeaser from "../fundamentals/stockFundamentalTeaser";
import Plot from "react-plotly.js";
import {fetchMarketIndices, fetchPage} from "../../api";
import MarketBreadth from "./market_breadth";
import SectorPerformance from "./sector_performance";
import LiveMarketOverview from "../marketsnap";


const MarketIndices = () => {
  const [indices, setIndices] = useState(["NIFTY 50"]);
  const [granularity, setGranularity] = useState("1D"); // Display granularity
  const [chartType, setChartType] = useState("candles");
  const [selectedIndex, setSelectedIndex] = useState("");

  const GRANULARITIES = ["1m", "5m", "10m", "30m", "1H", "1D", "1M", "3M", "6M", "1Y"];

  // useEffect(() => {
  //   fetchMarketIndices().then((data) => {
  //     const parsed = JSON.parse(data.hist_df);
  //     setIndices(parsed);
  //     if (parsed.length > 0) setSelectedIndex(parsed[0].symbol);
  //   });
  // }, []);

//   useEffect(() => {
//   fetchMarketIndices(true).then((data) => {
//     const parsed = JSON.parse(data.hist_df);
//     const filtered = parsed.filter((item) =>
//       item && typeof item.symbol === "string" &&
//       (item.symbol === "NIFTY 50" || item.symbol === "NIFTY BANK")
//     );
//     setIndices(filtered);
//     if (filtered.length > 0) setSelectedIndex(filtered[0].symbol);
//   });
// }, []);
    const allowedSymbols = ["NIFTY 50", "NIFTY BANK", "INDIA VIX","NIFTY IT", "NIFTY AUTO"];

    const fetchData = useCallback (async () => {
    fetchMarketIndices(true).then((data) => {
      const parsed = JSON.parse(data.hist_df);


      const filtered = parsed.filter((item) =>
        item && typeof item.symbol === "string" &&
        allowedSymbols.includes(item.symbol)
        // (item.symbol === "NIFTY 50" || item.symbol === "NIFTY BANK")
      );
      setIndices(filtered);
      // if (filtered.length > 0) setSelectedIndex(filtered[0].symbol);
      // if (filtered.length > 0) setSelectedIndex("NIFTY 50");
    });
  }, []);

    // Run only once: initial selection
    useEffect(() => {
      if (allowedSymbols.length > 0) {
        setSelectedIndex(allowedSymbols[0]);  // Set default ONCE
      }
    }, []);

    // Auto-refresh every 30 seconds
    useEffect(() => {
    fetchData();
    const intervalId = setInterval(fetchData, 30000);
    return () => clearInterval(intervalId);
  }, [fetchData]);

  // Manual Refresh
  const handleRefresh = () => {
    fetchData();
  };

  // Aggregate intraday tick-level data into OHLC candles
  const aggregateTicksToCandles = (ticks, frequencyMinutes) => {
    const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000; // +5:30 in milliseconds

    if (!Array.isArray(ticks) || ticks.length === 0) return [];

    const frequencyMs = frequencyMinutes * 60 * 1000;
    ticks.sort((a, b) => a.date - b.date);

    const candles = [];
    let currentCandle = null;

    for (const tick of ticks) {
      // const tickTime = new Date(tick.date).getTime();
      const tickTime = new Date(tick.date).getTime() + IST_OFFSET_MS;

      // console.log('TICKS',tick)

      if (!currentCandle) {
        const candleStart = Math.floor(tickTime / frequencyMs) * frequencyMs;
        currentCandle = {
          date: new Date(candleStart).toISOString(),
          open: tick.close,
          high: tick.close,
          low: tick.close,
          close: tick.close,
        };
        console.log('currentCandle',currentCandle)

      } else {
        const currentCandleEnd = new Date(currentCandle.date).getTime() + frequencyMs;

        if (tickTime < currentCandleEnd) {
          currentCandle.high = Math.max(currentCandle.high, tick.close);
          currentCandle.low = Math.min(currentCandle.low, tick.close);
          currentCandle.close = tick.close;
        } else {
          candles.push(currentCandle);

          const candleStart = Math.floor(tickTime / frequencyMs) * frequencyMs;
          currentCandle = {
            date: new Date(candleStart).toISOString(),
            open: tick.close,
            high: tick.close,
            low: tick.close,
            close: tick.close,
          };
        }
      }
    }

    if (currentCandle) candles.push(currentCandle);

    return candles;
  };

  const filteredData = useMemo(() => {
    const selected = indices.filter((d) => d.symbol === selectedIndex);
    // const now = new Date();
    // var today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    var today = new Date();
    // today = new Date(today.getTime() - (48*60*60*1000));
    today.setHours(0, 0, 0, 0);
    const todayEpoch = today.getTime();
    if (["1m", "5m", "10m", "30m", "1H"].includes(granularity)) {
      // const intradayOnly = selected.filter((d) => new Date(d.date).getTime() >= today);
    const intradayOnly = selected.filter((d) => new Date(d.date).getTime() >= todayEpoch);
    console.log('INTRADAY DATA ',intradayOnly)
      let freqMinutes = 5;
      if (granularity === "1m") freqMinutes = 1;
      if (granularity === "10m") freqMinutes = 10;
      if (granularity === "30m") freqMinutes = 30;
      if (granularity === "1H") freqMinutes = 60;

      return aggregateTicksToCandles(intradayOnly, freqMinutes);
    } else {
      // For daily, monthly, etc. – group by date/month/year
      const grouped = {};
      selected.forEach((item) => {
        const date = new Date(item.date);
        let key;
        if (granularity === "1D") key = date.toISOString().slice(0, 10);
        else if (granularity === "1M") key = `${date.getFullYear()}-${date.getMonth() + 1}`;
        else if (granularity === "3M") {
          const quarter = Math.floor(date.getMonth() / 3) + 1;
          key = `${date.getFullYear()}-Q${quarter}`;
        } else if (granularity === "6M") {
          const half = date.getMonth() < 6 ? "H1" : "H2";
          key = `${date.getFullYear()}-${half}`;
        } else if (granularity === "1Y") key = `${date.getFullYear()}`;

        if (!grouped[key]) {
          grouped[key] = {
            date: key,
            open: item.open,
            high: item.high,
            low: item.low,
            close: item.close,
            count: 1,
          };
        } else {
          grouped[key].high = Math.max(grouped[key].high, item.high);
          grouped[key].low = Math.min(grouped[key].low, item.low);
          grouped[key].close = item.close;
          grouped[key].count += 1;
        }
      });

      return Object.keys(grouped)
        .sort()
        .map((k) => ({
          date: k,
          open: grouped[k].open,
          high: grouped[k].high,
          low: grouped[k].low,
          close: grouped[k].close,
        }));
    }
  }, [indices, selectedIndex, granularity]);

  const plotData = chartType === "line"
    ? [
        {
          x: filteredData.map((d) => d.date),
          y: filteredData.map((d) => d.close),
          type: "scatter",
          mode: "lines",
          name: selectedIndex,
          line: { color: "blue" },
        },
      ]
    : [
        {
          x: filteredData.map((d) => d.date),
          open: filteredData.map((d) => d.open),
          high: filteredData.map((d) => d.high),
          low: filteredData.map((d) => d.low),
          close: filteredData.map((d) => d.close),
          type: "candlestick",
          name: selectedIndex,
          increasing: { line: { color: '#49b249', width: 1 }, fillcolor: '#49b249' },   // Wick visible, body fill green
          decreasing: { line: { color: '#e57272', width: 1 }, fillcolor: '#e57272' },     // Wick visible, body fill red
        },
      ];

  return (
    <div style={styles.container}>
      <div style={styles.chartContainer}>
        <div style={styles.header}>
          <h3 style={styles.title}>{selectedIndex}</h3>
          <div style={styles.timeframeContainer}>

          {/* Refresh Icon */}
          <span
            style={{ marginLeft: "16px", cursor: "pointer", fontSize: "1rem" }}
            title="Refresh"
            onClick={handleRefresh}
          >
            🔄
          </span>
            {GRANULARITIES.map((g) => (
              <span
                key={g}
                onClick={() => setGranularity(g)}
                style={{
                  ...styles.timeframeOption,
                  textDecoration: granularity === g ? "underline" : "none",
                  fontWeight: granularity === g ? "bold" : "normal",
                }}
              >
                {g}
              </span>
            ))}

            <span
              onClick={() => setChartType("line")}
              style={{
                ...styles.iconToggle,
                fontWeight: chartType === "line" ? "bold" : "normal",
                color: chartType === "line" ? "blue" : "black",
              }}
              title="Line Chart"
            >
              📈
            </span>

            <span
              onClick={() => setChartType("candlestick")}
              style={{
                ...styles.iconToggle,
                fontWeight: chartType === "candlestick" ? "bold" : "normal",
                color: chartType === "candlestick" ? "blue" : "black",
              }}
              title="Candlestick Chart"
            >
              📊
            </span>
          </div>
        </div>

        <Plot
          data={plotData}
          layout={{
            height: 600,
            xaxis: {
              title: "Date",
              type: "date",
              rangeslider: { visible: false },
              showgrid: true,
              gridcolor: "slategray",        // ← WHITE GRID
              showline: true,
              showticklabels: true,
              minor: {
                ticklen: 4,
                showgrid: true,
                gridcolor: "slategray",        // ← WHITE GRID
                dtick: "M1", // For minor ticks every month (adjust as needed)
              },
            },
            yaxis: {
              title: "Price",
              tickformat: ",",
              showgrid: true,
              gridcolor: "slategray",        // ← WHITE GRID
              showline: true,
              showticklabels: true,
              minor: {
                ticklen: 2,
                showgrid: true,
                gridcolor: "slategray",        // ← WHITE GRID
                dtick: 1000, // Example minor tick spacing, adjust based on data
              },
            },
            // plot_bgcolor: "#f3f0ec",
            plot_bgcolor: "#010507",
            paper_bgcolor: "transparent",
           //  candlestick: {
           //    increasing: { line: { width: 0 } },
           //    decreasing: { line: { width: 0 } },
           // },
          }}
          config={{ displayModeBar: false }}
          style={{ width: "100%", height: "100%" }}
        />
      </div>

      <div style={styles.sidebar}>
        <ul style={styles.tickerList}>
          {Array.from(new Set(indices.map((i) => i.symbol))).map((symbol) => (
            <li
              key={symbol}
              onClick={() => setSelectedIndex(symbol)}
              style={{
                ...styles.tickerItem,
                fontWeight: selectedIndex === symbol ? "bold" : "normal",
              }}
            >
              {symbol}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MarketIndices;


// ✅ CSS-in-JS (Replacing Tailwind)
const styles = {
  container: {
    display: "flex",
    padding: "16px",
    border: "1px solid #ccc",      // thin border
    borderRadius: "10px",          // curved corners
    backgroundColor: "#fff",
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",

  },
  chartContainer: {
    width: "93%",
    paddingRight: "16px",
  },
  sidebar: {
    width: "7%",
    padding: "16px",
    borderLeft: "1px solid #ccc",
    borderTopRightRadius: "10px",   // match container curve
    borderBottomRightRadius: "10px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "5px",
  },
  title: {
    fontSize: "1.25rem",
    fontWeight: "bold",
  },
  timeframeContainer: {
    display: "flex",
    gap: "12px",
  },
  timeframeOption: {
    cursor: "pointer",
    color: "#555",
  },
  sidebarTitle: {
    fontSize: "1rem",
    fontWeight: "bold",
    marginBottom: "8px",
  },
  tickerList: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
  },
  tickerItem: {
    cursor: "pointer",
    color: "#555",
    padding: "4px 0",
    borderBottom: "1px dashed #ccc",
    transition: "color 0.2s",
  },
    iconToggle: {
    cursor: "pointer",
    fontSize: "1rem",
    margin: "0 0px",
  },
};
